/*
* Copyright (c) Akveo 2019. All Rights Reserved.
* Licensed under the Single Application / Multi Application License.
* See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
*/
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';
const API_URL = environment.apiUrl + 'blog';
@Injectable(
    {
        providedIn: "root"
    }
)
export class BlogService {
    authtoken: string;
    private httpOptions;
    constructor(private http: HttpClient, private token: TokenStorageService) {
        this.authtoken = this.token.getToken();
        this.httpOptions = {
            headers: new HttpHeaders()
                .set("Content-Type", "application/json")
                .set('Authorization', `Bearer ${this.authtoken}`)
        };
    }
    getBlogListwithoutAuth(query): Observable<any> {
        return this.http.get<any>(API_URL + "/v1"+query);
    }
    getBlogList(query): Observable<any> {
        return this.http.get<any>(API_URL + query, this.httpOptions);
    }
    getBlog(id: string) {
        return this.http.get<any>(`${API_URL}/${id}`, this.httpOptions);
    }
    getBlogwithoutAuth(id: string) {
        return this.http.get<any>(API_URL+"/v1/"+id);
    }
    addBlog(Blog) {
        return this.http.post<any>(API_URL, Blog, this.httpOptions);
    }
    editBlog(Blog, id: string): Observable<any> {
        return this.http.put(API_URL + '/' + id, Blog, this.httpOptions);
    }
}
